import { useLocation, useSearchParams } from "react-router-dom";
import { Button } from "@/components";

export type actionFor = "client" | "user" | "region";

enum BUTTON_MAP {
  "user" = "Add User",
  "client" = "Add Client",
  "region" = "Add Region",
}

export const Actions = ({
  action,
  query,
}: {
  action: actionFor;
  query: string;
}) => {
  const [_, setSearchParams] = useSearchParams();
  const location = useLocation();
  const isV2Pathname = location.pathname.includes('administrationv2')

  const handleOpenModal = () => {
    setSearchParams((searchQuery) => {
      searchQuery.set(query, "true");
      return searchQuery;
    });
  };

  return (
    <Button onClick={handleOpenModal}>
      { isV2Pathname ? (<img src="/plus.svg" alt="Plus icon" style={{width: '15px', height: '15px', marginRight: '10px'}}/>) : null }
      {BUTTON_MAP[action]}
    </Button>
  );
};
